export const INDUSTRIES = [
    "Small Business",
    "Nonprofit",
    "Restaurant / Hospitality",
    "Parks & Recreation / Community Organization",
    "Education / CTE / Workforce Development",
    "Local Service Business",
    "Retail / E-commerce",
    "Healthcare / Wellness",
    "Professional Services",
    "Other",
];

/**
 * Question shape:
 *  - id, title, options
 *  - multi: true     → allow multiple selections (stored as array)
 *  - exclusive: [..] → these options, when selected, deselect everything else (and vice versa)
 *  - scale: true     → 1-5 numeric scale (single)
 */
export const QUESTIONS = [
    {
        id: "q1_goal",
        title: "What is your biggest marketing goal right now?",
        multi: true,
        exclusive: ["We are not sure"],
        options: [
            "Get more leads or inquiries",
            "Increase sales",
            "Increase event, program or class participation",
            "Improve awareness in the community",
            "Attract donors, sponsors or partners",
            "Recruit staff, volunteers or members",
            "Look more professional",
            "Launch something new",
            "Explain what we do more clearly",
            "We are not sure",
        ],
    },
    {
        id: "q2_challenge",
        title: "What feels hardest about marketing right now?",
        multi: true,
        exclusive: ["We are not sure what is working"],
        options: [
            "We do not know what to do next",
            "Our website feels outdated",
            "Our branding feels inconsistent",
            "We are not getting enough leads, sales or signups",
            "People do not understand what we do",
            "We do not have enough time",
            "Our competitors look more polished",
            "We have ideas but no clear plan",
            "We are not sure what is working",
        ],
    },
    {
        id: "q3_website",
        title: "How would you describe your current website?",
        options: [
            "We do not have one",
            "It exists but feels outdated",
            "It looks okay but does not generate results",
            "It needs better content or structure",
            "It works well enough for now",
            "It works well and feels current",
            "Not sure",
        ],
    },
    {
        id: "q4_messaging",
        title: "How clear is your current messaging?",
        options: [
            "We struggle to explain what we do",
            "It makes sense to us but not always to others",
            "It is somewhat clear but could be stronger",
            "It is mostly clear",
            "It is very clear and consistent",
        ],
    },
    {
        id: "q5_brand",
        title: "How do your logo, colors, graphics and materials feel right now?",
        multi: true,
        exclusive: ["Not sure"],
        options: [
            "Outdated",
            "Inconsistent",
            "Fine but not very memorable",
            "Mostly professional",
            "Strong and consistent",
            "Not sure",
        ],
    },
    {
        id: "q6_social",
        title: "How would you describe your social media presence?",
        options: [
            "We rarely post",
            "We post when we remember",
            "We post regularly but without much strategy",
            "We have a plan but need stronger content",
            "We are consistent and confident",
            "We do not use social media much",
        ],
    },
    {
        id: "q7_visual",
        title: "How often do you use current photo or video content?",
        multi: true,
        exclusive: ["Not sure"],
        options: [
            "Almost never",
            "Occasionally",
            "We have some but need more",
            "We use it often",
            "We have strong photo and video assets",
            "Not sure",
        ],
    },
    {
        id: "q8_approach",
        title: "Which best describes your marketing approach?",
        options: [
            "We are mostly reacting as things come up",
            "We try different things but do not have a clear plan",
            "We have a plan but struggle to follow through",
            "We are consistent but want better results",
            "We are ready to grow and need expert direction",
        ],
    },
    {
        id: "q8b_staffing",
        title: "Does your organization have any marketing staff or use an outside contractor at this time?",
        options: [
            "No one — we handle it ourselves (owner/leadership)",
            "One or more in-house staff members",
            "A freelancer or part-time contractor",
            "A marketing agency",
            "A mix of in-house staff and outside help",
        ],
    },
    {
        id: "q9_confidence",
        title: "How confident are you that your marketing is helping you grow?",
        scale: true,
        options: [
            { value: 1, label: "Not confident" },
            { value: 2, label: "Slightly confident" },
            { value: 3, label: "Somewhat confident" },
            { value: 4, label: "Mostly confident" },
            { value: 5, label: "Very confident" },
        ],
    },
    {
        id: "q10_help",
        title: "What type of help would be most useful right now?",
        multi: true,
        exclusive: ["Not sure", "All of the above"],
        options: [
            "A clear marketing plan",
            "Better branding",
            "A better website",
            "Social media content",
            "Photo or video content",
            "Help knowing what to prioritize",
            "Ongoing marketing support",
            "All of the above",
            "Not sure",
        ],
    },
    {
        id: "q11_timeline",
        title: "When are you hoping to make improvements?",
        options: [
            "As soon as possible",
            "Within the next 1–3 months",
            "Within the next 3–6 months",
            "Later this year",
            "We are just exploring",
        ],
    },
];
